<template>
  <div class="app flex-row align-items-center col-md-6 col-xl-6 col-12 seethrough">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card no-body class="p-4">
            <b-card-body>
              <h1>Login</h1>
              <p class="text-muted">Sign In to your account</p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-user"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <input
                  type="text"
                  class="form-control"
                  v-model="formData.username"
                  placeholder="Username"
                  @keyup.enter="submitData"
                />
              </b-input-group>
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <input
                  type="password"
                  class="form-control"
                  v-model="formData.password"
                  placeholder="Password"
                  @keyup.enter="submitData"
                />
              </b-input-group>
              <b-row>
                <b-col cols="12">
                  <b-button @click="submitData" variant="primary" class="px-4">Login</b-button>
                  <div style="float:right; font-weight: bold;">
                    Or Sign In using:
                    <g-signin-button
                      :params="googleSignInParams"
                      @success="onSignInSuccess"
                      @error="onSignInError"
                      style="margin-left: 10px;"
                    >
                      <i class="fa fa-google"></i>
                    </g-signin-button>

                    <fb-signin-button
                      :params="fbSignInParams"
                      @success="onSignInSuccessFB"
                      @error="onSignInError"
                    >
                      <i class="fa fa-facebook"></i>
                    </fb-signin-button>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6" class="text-left">
                  <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                  <b-button
                    type="button"
                    variant="link"
                    v-b-modal="'modalforgotpassword'"
                    style="margin-bottom:  10px;float:left;"
                  >
                    <i class="fa fa-question-circle"></i> Forgot password?
                  </b-button>
                  <b-modal
                    :id="'modalforgotpassword'"
                    ok-only
                    ok-variant="secondary"
                    ok-title="Close"
                    centered
                  >
                    <div class="modal-window">
                      <div v-if="!this.$data.forgotNext">
                        <h3 style="text-align:center;">Account recovery</h3>
                        <h4 style="text-align:center;">Recover your Newport Account</h4>
                        <b-form id="forgotForm">
                          <b-form-group>
                            <b-row>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text>Username (phone/email)</b-input-group-text>
                                </b-input-group-prepend>
                                <b-form-input
                                  type="text"
                                  id="forgotUsername"
                                  v-model="formData.forgotUsername"
                                  placeholder="Username"
                                ></b-form-input>
                                <b-input-group-append>
                                  <b-input-group-text>
                                    <i class="nav-icon icon-people"></i>
                                  </b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </b-row>
                            <b-row>
                              <b-col cols="12">
                                <b-button
                                  @click="handleOk()"
                                  type="button"
                                  size="sm"
                                  variant="primary"
                                  style="float:right; margin-top: 10px;"
                                >Next</b-button>
                              </b-col>
                            </b-row>
                          </b-form-group>
                        </b-form>
                      </div>
                      <div v-if="this.$data.forgotNext">
                        New password is send using SMS.
                        <br />
                        <br />Please check your phone for new temporary password.
                        <br />Temporary Password valid for 15 minutes
                      </div>
                    </div>
                  </b-modal>
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col cols="6" class="text-right">
                  <b-button variant="link" class="px-0">Don't have account? Sign Up Here</b-button>
                </b-col>
              </b-row>-->
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import GSignInButton from 'vue-google-signin-button'
import FBSignInButton from 'vue-facebook-signin-button'
const constants = require('../base/shared/constants')
window.fbAsyncInit = function () {
  FB.init({
    appId: constants.NEWPORT_CONST.FACEBOOK_ID,
    cookie: true, // enable cookies to allow the server to access the session
    xfbml: true, // parse social plugins on this page
    version: constants.NEWPORT_CONST.FACEBOOK_API_VERSION // use graph api version v2.8
  })
};
(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = '//connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
})(document, 'script', 'facebook-jssdk')

let qs = require('qs')
Vue.use(GSignInButton)
Vue.use(FBSignInButton)

const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/users/signin_local'
const API_LOCATIONS = BASE + '/api/locations/list'
const API_CHECK_USERNAME = BASE + '/api/users/check_username'
const API_FORGOT_PASSWORD = BASE + '/api/users/forgotPassword'
const API_GOOGLE = BASE + '/api/users/signin_google'
const API_FACEBOOK = BASE + '/api/users/signin_facebook'
const API_LOCATIONS_SIMPLE = BASE + '/api/locations/simpleList'
const API_LOCKS_LIST = BASE + '/api/locks/list'
const API_USER_DETAIL = BASE + '/api/users/detail'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  }).then(res => res.json())
}

function postdataAuth (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'Authorization': localStorage.getItem('token')
    },
    method: 'POST'
  }).then(res => res.json())
}

async function getLocationsSimpleList () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    searchTerm: '',
    limit: 10
  }
  let res = await postdataAuth(API_LOCATIONS_SIMPLE, parameters)
  return res.locations
}


async function getLocations () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token')
  }
  let res = await postdataAuth(API_LOCATIONS, parameters)
  return res
}

async function checkUserName (userName) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    username: userName
  }
  let res = await postdata(API_CHECK_USERNAME, parameters)
  return res
}

async function activateForgotPassword (userName) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    userId: userName
  }
  let res = await postdata(API_FORGOT_PASSWORD, parameters)
  return res
}

async function locksList () {
  let param = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    // locationId: localStorage.getItem('locationId')
  }
  let res = await postdataAuth(API_LOCKS_LIST, param)
  return res.locks
}

async function userDetail() {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    access_token: localStorage.getItem("token")
  };

  let res = await postdataAuth(API_USER_DETAIL, parameters);
  return res.user;
}




export default {
  name: 'Login',
  data () {
    return {
      googleUser: {},
      facebookUser: {},
      facebookImg: {},
      googleSignInParams: {
        client_id: constants.NEWPORT_CONST.GOOGLE_ID
      },
      fbSignInParams: {
        scope: 'email,user_likes',
        return_scopes: true
      },
      formData: {
        username: null,
        password: null,
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        hausUser: true
      },
      forgotNext: false,
      forgotUserName: ''
    }
  },
  beforeCreate: function () {
    document.body.className = 'loginpage'
  },
  methods: {
    submitData (evt) {
      evt.preventDefault()
      postdata(API, this.formData)
        .then(response => {
          if (response.status.errCode !== '200') {
            this.formData.password = ''
            this.formData.username = ''
            if (response.status.errCode === '403') {
              alert('Your account is not activated. \nPlease contact Newport.')
            } else {
              alert('Incorrect Email/Password')
            }
          } else {
            this.successLogin(response)

            localStorage.setItem('avatar', response.avatar)
            localStorage.setItem('signinMethod', 'local')


          }
        })
        .catch(error => {
          console.error(error)
        })

    },
    onReset (evt) {
      evt.preventDefault()
      /* Reset our form values */
      this.formData.username = ''
      this.formData.password = ''
      /* Trick to reset/clear native browser form validation state */
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    handleOk () {
      const thisForm = document.getElementById('forgotForm') // should be unique, maybe ID of location should be added
      this.formData.forgotUserName = thisForm.forgotUsername.value
      checkUserName(this.formData.forgotUserName)
        .then(data => {
          if (data.is_registered == null) {
            // not found
            alert('Given username is not found. Please try again')
          } else {
            if (data.uid > 0) {
              // forward to next page
              activateForgotPassword(this.formData.forgotUserName)
                .then(data => {
                  console.log(data)
                })
                .catch(error => {
                  console.error(error)
                })
              this.$data.forgotNext = true
            } else {
              // unknown error
              console.log(
                'unknown error for forgot password for username: ' +
                  this.formData.forgotUserName
              )
            }
          }
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    // use by google
    onSignInSuccess (googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      const profile = googleUser.getBasicProfile() // etc etc
      var id_token = googleUser.getAuthResponse().id_token
      let parameters = {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        g_id: profile.getId(),
        access_token: id_token
      }
      // login to HAUS API
      postdata(API_GOOGLE, parameters)
        .then(data => {
          console.log(data)
          if (data.status.errCode !== '200') {
            alert('Incorrect Email/Password')
          }
          if (data.hausType == null) {
            alert('You do not have access to HAUS. Please contact Newport.')
          } else if (data.hausType >= 0) {
            this.successLogin(data)
            localStorage.setItem('name', profile.getName())
            localStorage.setItem('signinMethod', 'google')
            localStorage.setItem('avatar', data.avatar)
          } else {
            alert('Please contact Newport.')
          }
        })
        .catch(error => {
          console.error(error)
        })
    },

    // facebook signin
    onSignInSuccessFB (fbUser) {
      FB.getLoginStatus(function (response) {
        FB.api('/me', userFB => {
          console.log(`Good to see you, ${userFB.name}.`)
          localStorage.setItem('name', userFB.name) // full name. from api we only got first name
        })
      })
      this.$data.facebookUser = fbUser
      let facebookuserid = fbUser.authResponse.userID
      // getting picture
      FB.api(
        '/' + facebookuserid + '/picture?redirect=false',
        'GET',
        {},
        function (response) {
          localStorage.setItem('avatar', response.data.url)
        }
      )
      var accessToken = fbUser.authResponse.accessToken
      let parameters = {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        fb_id: facebookuserid,
        access_token: accessToken
      }
      postdata(API_FACEBOOK, parameters)
        .then(data => {
          console.log(data)
          if (data.hausType === null) {
            alert('You do not have access to HAUS. Please contact Newport.')
          } else if (data.hausType >= 0) {
            this.successLogin(data)
            localStorage.setItem('signinMethod', 'facebook')
          } else {
            // unknown error
            alert('Please contact Newport.')
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    // use both google and facebook on error signin
    onSignInError (error) {
      console.log('Error on signin to google/facebook: ', error)
    },
    successLogin (data) {
      localStorage.setItem('ouht', data.hausType)
      localStorage.setItem('token', data.token)
      localStorage.setItem('ouid', data.uid)
      localStorage.setItem('showmenu', 'default')
      getLocations().then(response => {
        if (response.status.errCode === '200' && response.locations.length > 0) {
          let favLocId = localStorage.getItem('favLocation')
          if (favLocId) {
            localStorage.setItem('locationId', favLocId)
          } else {
            localStorage.setItem('locationId', response.locations[0].id)
          }

          localStorage.setItem('owid', response.locations[0].owner.id)
          localStorage.setItem('localLocationsList', JSON.stringify(response.locations))
          
        } else {
          localStorage.setItem('locationId', 0)
          localStorage.setItem('localLocationsList', '[]')
          localStorage.setItem('owid', data.uid)
        }

        // getLocationsSimpleList().then(response => {
        //   localStorage.setItem('localLocationsList', JSON.stringify(response))

          locksList().then(resp => {
            //console.log(JSON.stringify(resp))
            let localLockList = resp
            let locId = localStorage.getItem('locationId')
            localStorage.setItem('localLocksList', JSON.stringify(localLockList))
            
            //let foundLoc = localLockList.filter(lock => lock.locationId == locId)
    
            // if(localLockList) {
              
            //   let locksForLocation = JSON.stringify(resp.filter(lock => lock.locationId == locId))
            //   localStorage.setItem('locksForLocation', locksForLocation)
              
            // }
            //alert('start to execute')

            // let localLocksList = localStorage.getItem('localLocksList')
            // localLocksList = JSON.parse(localLocksList)
            
            
            //alert('End Executing')

            userDetail().then(respo => {
              document.body.className = ''

              localStorage.setItem('localUserDetail', JSON.stringify(respo))
              this.$router.push({
                name: 'Newport'
              })
            })
          })
        //})
      })
    }
  }
}
</script>

<style>
body.loginpage {
  background-image: url("/static/img/office.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
}

.seethrough {
  opacity: 0.9;
}

.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 5px 5px 0 #0f69ff;
  float: right;
}

.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  box-shadow: 5px 3px 0 #42678e;
  background-color: #4267b2;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/Login.vue